import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative w-full pb-2" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "absolute z-10 w-full mt-1 bg-black rounded max-h-60 overflow-auto"
}
const _hoisted_4 = ["onClick"]

import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { chevronDown as chevronDownIcon } from 'ionicons/icons';

interface Country {
	value: string;
	label: string;
	flagClass: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
    modelValue: {},
    availableCountries: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const isOpen = ref(false);

const toggleDropdown = () => {
	isOpen.value = !isOpen.value;
};

const selectCountry = (value: string) => {
	emit('update:modelValue', value);
	isOpen.value = false;
};

const selectedOption = computed(() => props.availableCountries.find((c) => c.value === props.modelValue));

onMounted(() => {
	if (!props.modelValue && props.availableCountries.length > 0) {
		emit('update:modelValue', props.availableCountries[0].value);
	}
});

// Close dropdown when clicking outside
document.addEventListener('click', (e) => {
	const path = e.composedPath?.() || [];
	if (!path.some((el: any) => el?.classList?.contains('relative'))) {
		isOpen.value = false;
	}
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex items-center justify-between px-4 py-2 rounded cursor-pointer text-white",
      onClick: toggleDropdown
    }, [
      _createElementVNode("div", _hoisted_2, [
        (selectedOption.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(selectedOption.value.flagClass),
              style: {"width":"1.5em","height":"1em","display":"inline-block"}
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(selectedOption.value?.label || _unref(t)('top_up.country_select')), 1)
      ]),
      _createVNode(_component_ion_icon, { icon: _unref(chevronDownIcon) }, null, 8, ["icon"])
    ]),
    _createVNode(_Transition, { name: "dropdown-fade" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCountries, (country) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: country.value,
                  class: "flex items-center gap-2 px-4 py-2 hover:bg-white/10 cursor-pointer text-white",
                  onClick: ($event: any) => (selectCountry(country.value))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(country.flagClass),
                    style: {"width":"1.5em","height":"1em","display":"inline-block"}
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('countries.' + country.value)), 1)
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})